export type KeywordMapping = {
  phrases: string[];
  property: 'tag' | 'productType';
  value: string;
};

export const KEYWORD_MAPPINGS: KeywordMapping[] = [
  {
    phrases: ['meal kit', 'recipe'],
    property: 'productType',
    value: 'Meal Kit',
  },
  {
    phrases: ['ready to eat', 'ready meal', 'no cook', 'rte', 'microwavable', 'microwave', 'quick'],
    property: 'productType',
    value: 'Ready to Eat',
  },
  {
    phrases: ['grocery', 'pantry'],
    property: 'productType',
    value: 'Grocery',
  },
  {
    phrases: ['high fiber', 'high-fiber', 'fiber'],
    property: 'tag',
    value: 'High Fiber',
  },
  {
    phrases: ['high protein', 'high-protein', 'protein'],
    property: 'tag',
    value: 'High-Protein',
  },
  {
    phrases: ['gluten free', 'gluten-free', 'no gluten', 'celiac'],
    property: 'tag',
    value: 'Gluten-Free',
  },
  {
    phrases: ['low calorie', 'low cal', 'light', 'lite', 'diet', 'reduced calorie', '600 calorie', 'test'],
    property: 'tag',
    value: '<600 Calories',
  },
  {
    phrases: ['low sodium', 'low salt', 'reduced sodium', 'sodium restricted'],
    property: 'tag',
    value: 'Low Sodium',
  },
  {
    phrases: ['nut-free', 'nut free', 'nut allergy', 'nut-safe', 'nut safe'],
    property: 'tag',
    value: 'Nut-Free',
  },
  {
    phrases: ['soy-free', 'soy free', 'soy allergy'],
    property: 'tag',
    value: 'Soy-Free',
  },
];

export function checkKeywordMatch(query: string): KeywordMapping[] {
  if (!query) return [];
  const q = query.toLowerCase();
  return KEYWORD_MAPPINGS.filter((m) => m.phrases.some((phrase) => q.includes(phrase)));
}
